import React from "react";
import PropTypes from "prop-types";
import Variant from "../../../../models/Variant";
import Track from "../../models/Track";

function HighlightVariant({ track, variant }) {
  function handleClick() {
    track.setSharedState({ selectedVariantId: variant.id });
  }

  return track && variant?.id ? (
    <div
      data-tooltip="Highlight Variant"
      data-tooltip-class="genome-browser-small-tooltip"
      className="tw-inline-block"
      onClick={handleClick}
    >
      <div className="hover:tw-text-blueGray-900 tw-flex tw-text-blueGray-700 tw-cursor-pointer">
        <i className="fa fa-check-circle" />
      </div>
    </div>
  ) : null;
}

HighlightVariant.propTypes = {
  track: PropTypes.instanceOf(Track).isRequired,
  variant: PropTypes.instanceOf(Variant),
};

HighlightVariant.defaultProps = {
  variant: null,
};

HighlightVariant.propTypes = {};

export default HighlightVariant;
